import { css } from '../../../styled-system/css';
import { H1 } from '../../ui/font/headings/components/H1';
import { ProfileMenu } from './ProfileMenu';

export const TopNav = () => {
  return (
    <header
      className={css({
        alignItems: 'center',
        backgroundColor: 'headerBg',
        display: 'flex',
        height: '14',
        justifyContent: 'space-between',
        paddingLeft: '4',
        paddingRight: '4',
      })}
    >
      <H1 use="appName">Kaddo Foundry</H1>
      <ProfileMenu />
    </header>
  );
};
